{
  "version": 1,
  "asset_id": "2e811bcb-369c-4d5a-911e-ba6b9895bebd",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/2e811bcb-369c-4d5a-911e-ba6b9895bebd/ind-real-estate-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/2e811bcb-369c-4d5a-911e-ba6b9895bebd/ind-real-estate-640.webp",
  "original_filename": "ind-real-estate-640.webp",
  "size": 6776,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:10Z"
}
